import api, { headers, COURSES_URL } from "./api";

/**
 *
 * @returns
 */
export const fetchAllCourses = async () => {
  return await api.get(`${COURSES_URL}/getAllCourses`, { headers });
};

export const fetchCoursesDataOnSearch = async (
  subject,
  gender,
  modeOfTeaching,
  city,
  area,
  level,
  qualificationLevel,
  educationBoard,
  sortBy,
  page = 1
) => {
  // return await api.get(`${COURSES_URL}/search?query=${subject}`);
  return await api.get(
    `${COURSES_URL}/search?query=${subject || ""}&gender=${
      gender || ""
    }&modeOfTeaching=${modeOfTeaching || ""}&cityId=${city || ""}&areaId=${
      area || ""
    }&course-level=${level || ""}&qualificationLevelId=${
      qualificationLevel || ""
    }&boardId=${educationBoard || ""}&sortBy=${sortBy || ""}&page=${page}
    `
  );
};

//

export const fetchCoursesDataOnSearch2 = async (
  subject,
  gender,
  modeOfTeaching,
  city,
  area,
  level,
  qualificationLevel,
  sortBy,
  page = 1
) => {
  return await api.get(
    `${COURSES_URL}/search2?query=${subject || ""}&gender=${
      gender || ""
    }&modeOfTeaching=${modeOfTeaching || ""}&cityId=${city || ""}&areaId=${
      area || ""
    }&course-level=${level || ""}&qualificationLevelId=${
      qualificationLevel || ""
    }&sortBy=${sortBy || ""}&page=${page}
    `
  );
};

export const getCourseHeaders = async () => {
  return await api.get(`/headers`);
};

export const getCourseSubjects = async (courseHeaderId) => {
  return await api.get(`/headers/${courseHeaderId}/subjects`);
};

export const getCourseLevels = async (courseHeaderId) => {
  return await api.get(`/headers/${courseHeaderId}/levels`);
};

export const CoursesSubmit = async (body) => {
  return await api.post(`/courses`, body);
};

export const getCourses = async (teacherId) => {
  return await api.get(`/teachers/${teacherId}/courses`);
};

export const updateCourseLevels = async (courseId, levels) => {
  return await api.put(`/courses/${courseId}/levels`, levels);
};

export const updateCourse = async (courseId, body) => {
  return await api.put(`/courses/${courseId}`, body);
};

export const updateExperties = async (courseId, body) => {
  return await api.put(`/courses/${courseId}/expert`, body);
};

// http://localhost:7250/courses/:courseId/expert

// export const getCourses = async (courseHeaderId, courseSubjectId) => {
//   return await api.get(
//     `/headers/${courseHeaderId}/subjects/${courseSubjectId}/courses`
//   );
// };
